import { createStructuredSelector} from 'reselect';
import { selectAccountID } from '../../../../selectors/globalSelectors';


const getExchangeActivityStates = (data) => data.exchangeActivity;

const getRecurringExchanges = (data) => {
    const { recurringExchanges } = getExchangeActivityStates(data);
    return recurringExchanges.data
}
const getRecurringExchangesLoading = (data) => {
    const { recurringExchanges } = getExchangeActivityStates(data);
    return recurringExchanges.isLoading
}
const getSingleExchanges = (data) => {
    const { singleExchanges } = getExchangeActivityStates(data);
    return singleExchanges.data
}
const getSingleExchangesLoading = (data) => {
    const { singleExchanges } = getExchangeActivityStates(data);
    return singleExchanges.isLoading
}
const getCancelSingle = (data) => {
    const { singleExchanges } = getExchangeActivityStates(data);
    return singleExchanges.cancel
}
const getCurrentTab = (data) => {
    const { currentTab } = getExchangeActivityStates(data);
    return currentTab.data
}
const getTab = (data) => {
    const { tab } = getExchangeActivityStates(data);
    return tab
}

// Exchange Activity
export const ExchangeActivityDerivedStates = createStructuredSelector({
  
    recurringExchanges: getRecurringExchanges ,
    singleExchanges:getSingleExchanges,
      isLoadingSingle:getSingleExchangesLoading,
      isLoadingRecurring: getRecurringExchangesLoading,
      accountID: selectAccountID,
      cancelSingle: getCancelSingle,
      currentTab: getCurrentTab,
    tab:getTab,
});
